const AddToWishlist = (data) => {
    if (!window.eS) return;

    const generalInfo = {};
    if (window.phone) generalInfo.user_phone = window.phone;
    if (window.email) generalInfo.user_email = window.email;

    window.eS('sendEvent', 'AddToWishlist', {
        'AddToWishlist': {
            // 'productKey': '24-MB02',            
            // 'price': '153',
            // 'isInStock': 1
            ...data
        },
        'GeneralInfo': {
            ...generalInfo
        }
    });
}

export default AddToWishlist;